import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Planner } from '@authority-labs/api-interfaces';
import { SelectPlannerDialogComponent } from '@check-list/app/modules/planners/select-planner-dialog/select-planner-dialog.component';
import { EntitySelectorDialogService } from '../../dialogs/entity-selector-dialog';
import { PlannerDialogService } from '../../dialogs/planner-dialog/planner-dialog.service';

@Component({
  selector: 'authority-labs-planner-selector',
  templateUrl: './planner-selector.component.html',
  styleUrls: ['./planner-selector.component.scss']
})
export class PlannerSelectorComponent {
  @Input() readonly = false;
  @Input() printPreview = false;
  @Input() planner: Planner = new Planner();
  @Output() plannerSelect: EventEmitter<Planner> = new EventEmitter();

  planners: Planner[] = [];

  constructor(
    private plannereDialog: PlannerDialogService,
    private entitySelectorDialogService: EntitySelectorDialogService
  ) {}

  selectPlanner(): void {
    this.entitySelectorDialogService
      .selectEntity(
        SelectPlannerDialogComponent,
        this.planner ? this.planner.id : undefined,
        this.readonly
      )
      .afterClosed()
      .subscribe((planner) => {
        if (planner) {
          this.planner = planner;
          this.plannerSelect.emit(this.planner);
        }
      });
  }

  newPlanner(): void {
    this.plannereDialog
      .create()
      .afterClosed()
      .subscribe((planner) => {
        if (planner) {
          this.plannerSelected(planner);
        }
      });
  }

  editPlanner(): void {
    this.plannereDialog
      .edit(this.planner)
      .afterClosed()
      .subscribe((planner) => {
        if (planner) {
          this.plannerSelected(planner);
        }
      });
  }

  private plannerSelected(planner: Planner): void {
    this.planner = planner;
    this.plannerSelect.emit(this.planner);
  }
}
